import { Button } from '@efexteam/components';
import { Actions, Can, Subjects, useRole } from '@efexteam/permission-manager';
import CallMadeIcon from '@mui/icons-material/CallMade';
import { selectProfileData } from '@pages/profile/store/selectors';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { WalletsStyles } from '../wallets.styles';

interface WalletActionsProps {
  onPayment: () => void;
  onDeposit: () => void;
  showConvertModal: () => void;
}

const WalletActions = ({
  onPayment,
  onDeposit,
  showConvertModal,
}: WalletActionsProps) => {
  const { t } = useTranslation();
  const userProfile = useSelector(selectProfileData);

  const { isPaymentAnalyst, isReadOnly } = useRole();

  if (isReadOnly) {
    return null;
  }

  return (
    <div className="flex flex-col flex-wrap gap-3 max-w-[450px]">
      <Can action={Actions.CREATE} subject={Subjects.PAYMENTS}>
        <Button
          appearance="primary"
          size={isPaymentAnalyst ? 'medium' : 'large'}
          onClick={onPayment}
          endIcon={<CallMadeIcon />}
          disabled={!userProfile?.canUserWithdraw}
        >
          {t(isPaymentAnalyst ? 'configureNewPayment' : 'makeNewPayment')}
        </Button>
      </Can>
      <div className={clsx(WalletsStyles.actionsSection)}>
        <Can action={Actions.CREATE} subject={Subjects.ADD_FUNDS}>
          <Button
            appearance="secondary"
            onClick={onDeposit}
            size={isPaymentAnalyst ? 'small' : 'large'}
          >
            {t('addFunds')}
          </Button>
        </Can>
        <Can action={Actions.CREATE} subject={Subjects.CONVERSIONS}>
          <Button
            appearance="secondary"
            onClick={showConvertModal}
            size={isPaymentAnalyst ? 'small' : 'large'}
            disabled={!userProfile?.canUserWithdraw}
          >
            {t(isPaymentAnalyst ? 'walletConfigureConvert' : 'convert')}
          </Button>
        </Can>
      </div>
    </div>
  );
};

export default WalletActions;
